import validate from '../../../services/reduxValidate.js'

export default function(data) {
  return validate(data, {
    oldPassword: { presence: { allowEmpty: false } },
    'newPassword.password': {presence: {allowEmpty: false}},
    'newPassword.confirmation': {presence: {allowEmpty: false}},
  })
}